import React from 'react';
import { motion } from 'framer-motion';
export function TomosGrid() {
  const tomos = [{
    num: 1,
    title: 'El Mapa del Enemigo',
    desc: 'Comprende la estructura del sistema financiero y los actores involucrados.'
  }, {
    num: 2,
    title: 'Derechos y Protección',
    desc: 'Conoce las leyes vigentes que te amparan como consumidor en Uruguay.'
  }, {
    num: 3,
    title: 'Comprender el Sistema',
    desc: 'Aprende cómo se manejan los registros y los plazos legales establecidos.'
  }, {
    num: 4,
    title: 'Estrategias y Opciones',
    desc: 'Explora las alternativas disponibles para abordar tu situación particular.'
  }, {
    num: 5,
    title: 'Herramientas Prácticas',
    desc: 'Modelos y recursos educativos para comunicarte formalmente.'
  }, {
    num: 6,
    title: 'Plan de Acción',
    desc: 'Pasos claros para organizar tus finanzas y proyectar un mejor futuro.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-surface-gray relative" data-id="element-331">
      <div className="max-w-6xl mx-auto" data-id="element-332">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-333">
          <h2 className="text-3xl md:text-5xl font-black text-slate-dark mb-4" data-id="element-334">
            El contenido del MegaPack
          </h2>
          <p className="text-xl text-slate font-medium" data-id="element-335">
            6 Tomos diseñados para darte claridad total.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-336">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-337">
              {/* Image Placeholder */}
              <div className="h-48 bg-brand-green/5 flex items-center justify-center border-b border-gray-100 relative overflow-hidden" data-id="element-338">
                <div className="absolute inset-0 bg-gradient-to-br from-brand-light/20 to-brand-green/20" data-id="element-339" />
                <span className="relative z-10 font-montserrat font-black text-4xl text-brand-green/30" data-id="element-340">
                  TOMO {tomo.num}
                </span>
              </div>

              <div className="p-6 flex flex-col flex-1" data-id="element-341">
                <div className="text-brand-green text-sm font-bold tracking-wider mb-2" data-id="element-342">
                  TOMO {tomo.num}
                </div>
                <h5 className="text-xl font-black text-slate-dark mb-3" data-id="element-343">
                  {tomo.title}
                </h5>
                <p className="text-slate text-sm leading-relaxed mt-auto" data-id="element-344">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm max-w-3xl mx-auto text-center" data-id="element-345">
          <h3 className="text-xl font-bold text-slate-dark mb-6" data-id="element-346">
            Además, dentro de cada tomo encontrarás:
          </h3>
          <div className="flex flex-col sm:flex-row justify-center gap-6 sm:gap-12" data-id="element-347">
            <div className="flex items-center justify-center gap-2 text-slate font-medium" data-id="element-348">
              <span className="text-brand-green font-bold" data-id="element-349">✓</span> Capturas
              reales del contenido
            </div>
            <div className="flex items-center justify-center gap-2 text-slate font-medium" data-id="element-350">
              <span className="text-brand-green font-bold" data-id="element-351">✓</span> Ejemplos
              internos
            </div>
            <div className="flex items-center justify-center gap-2 text-slate font-medium" data-id="element-352">
              <span className="text-brand-green font-bold" data-id="element-353">✓</span> Índice
              incluido
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}